import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Selectables } from 'src/app/business/swodoc/view-models/selectables-view-model';

@Component({
  selector: 'swodoc-node-checkbox',
  templateUrl: 'swodoc-node-checkbox.html',
  styleUrls: ['swodoc-node-checkbox.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SwodocNodeCheckbox {
  @Input() node: any;
  @Output() changed: EventEmitter<any> = new EventEmitter<any>();

  get value(): boolean {
    if (this.node.selectables && this.node.selectables.length > 0 && this.node.selectables[0].selected) {
      return this.node.selectables[0].selected;
    }
    return false;
  }
  set value(value: boolean) {
    const selectable = new Selectables();
    selectable.selected = value;
    this.node.selectables = this.node.selectables || [];
    if (this.node.selectables.length === 0) {
      this.node.selectables.push(selectable);
    } else {
      this.node.selectables[0] = selectable;
    }
    this.changed.emit(this.node);
  }
}
